<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="状态">
        <el-select v-model="query.status" size="small" clearable style="width:140px">
          <el-option label="全部" value="" />
          <el-option label="运行中" value="running" />
          <el-option label="成功" value="success" />
          <el-option label="失败" value="failed" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:rebuildTask:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('inventory:rebuildTask:list')" type="danger" plain size="small" @click="onlyFailed">仅看失败</el-button>
        <el-button v-if="isAuth('inventory:rebuildTask:list')" size="small" @click="load">刷新</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border v-loading="loading" :header-cell-style="headStyle" :row-class-name="rowClass">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="startTime" label="开始时间" min-width="150" />
      <el-table-column prop="endTime" label="结束时间" min-width="150" />
      <el-table-column prop="taskType" label="任务类型" width="120" />
      <el-table-column prop="startDate" label="起始日期" width="110" />
      <el-table-column prop="endDate" label="结束日期" width="110" />
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="tagType(scope.row.status)" size="mini">{{ statusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="operatorId" label="操作人" width="120" show-overflow-tooltip />
      <el-table-column label="信息" min-width="280">
        <template slot-scope="scope">
          <span>{{ scope.row.message || '' }}</span>
          <el-button v-if="scope.row.status === 'failed' && scope.row.message" type="text" size="mini" @click="copyMessage(scope.row.message)">复制原因</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="v => { pageSize = v; pageIndex = 1; load() }" @current-change="v => { pageIndex = v; load() }" />
  </div>
</template>
<script>
import request from '../../api/request'
import { authMixin } from './inventoryShared'
export default {
  name: 'RebuildTask',
  mixins: [authMixin],
  data() { return { query: { status: '' }, rows: [], pageIndex: 1, pageSize: 20, total: 0, loading: false, pollTimer: null } },
  created() { this.load(); this.startPoll() },
  beforeDestroy() { this.stopPoll() },
  methods: {
    search() { this.pageIndex = 1; this.load() },
    onlyFailed() { this.query.status = 'failed'; this.pageIndex = 1; this.load() },
    statusText(status) { return { running: '运行中', success: '成功', failed: '失败' }[status] || status || '-' },
    tagType(status) { return status === 'success' ? 'success' : (status === 'failed' ? 'danger' : 'warning') },
    rowClass({ row }) { return row && row.status === 'failed' ? 'row-failed' : '' },
    copyMessage(message) {
      if (!message) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(message).then(() => this.$message.success('失败原因已复制')).catch(() => this.fallbackCopy(message))
        return
      }
      this.fallbackCopy(message)
    },
    fallbackCopy(message) {
      const input = document.createElement('textarea')
      input.value = message
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$message.success('失败原因已复制')
      } catch (e) {
        this.$message.warning('复制失败，请手动复制')
      }
      document.body.removeChild(input)
    },
    startPoll() {
      this.stopPoll()
      this.pollTimer = setInterval(() => {
        if (this.loading) return
        const watching = !this.query.status || this.query.status === 'running' || this.rows.some(row => row.status === 'running')
        if (watching) this.load()
      }, 10000)
    },
    stopPoll() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    load() {
      this.loading = true
      request.get('/inventory/rebuildTask/list', { params: { status: this.query.status, pageIndex: this.pageIndex, pageSize: this.pageSize } }).then(res => {
        const body = res.data || {}
        this.rows = body.list || []
        this.total = body.totalCount || 0
      }).catch(() => { this.rows = []; this.total = 0 }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
/deep/ .el-table .row-failed > td { background: #fff2f0; }
</style>
